import { Component, OnDestroy } from '@angular/core'
import { NavigationStart, Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { RegistrationPageFilterStateService } from '@se-po/se-registration-ui-feature-open-registration-list'
import { AnalyticsService } from '@se-po/shared-data-access-services'
import { Subscription } from 'rxjs'
import { SeFeTab } from 'se-fe-tabs'

@Component({
  selector: 'app-open-registration',
  templateUrl: './open-registration.component.html',
  styleUrls: ['./open-registration.component.scss'],
  standalone: false,
})
export class OpenRegistrationComponent implements OnDestroy {
  public tabs: SeFeTab[]
  private readonly completedRegistrationsPath = '/user/registrations/completed'
  private readonly subscriptions = new Subscription()

  constructor(
    private translate: TranslateService,
    private analyticsService: AnalyticsService,
    private router: Router,
    private registrationFilterState: RegistrationPageFilterStateService,
  ) {
    this.tabs = [
      { routerLink: '/user/registrations/open', text: this.translate.instant('REGISTRATIONS.open_registrations') },
      { routerLink: this.completedRegistrationsPath, text: this.translate.instant('REGISTRATIONS.completed_registrations') },
    ]

    this.subscriptions.add(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart && !this.isRegistrationTabUrl(event.url)) {
          this.registrationFilterState.clearAll()
        }
      })
    )
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }

  public handleTabsClick(event: MouseEvent): void {
    const clickedTab = this.clickedTabElement(event)
    const href = clickedTab?.getAttribute('href') || ''

    if (href.includes(this.completedRegistrationsPath)) {
      this.analyticsService.seEvent('CompletedRegistrations')
    }
  }

  private clickedTabElement(event: MouseEvent): Element | null {
    const path = event.composedPath?.() || []
    const pathTab = path.find((target) => (
      target instanceof Element && target.matches('a[role="tab"]')
    ))

    if (pathTab instanceof Element) return pathTab

    let target = event.target
    if (target instanceof Text) {
      target = target.parentElement
    }

    return target instanceof Element ? target.closest('a[role="tab"]') : null
  }

  private isRegistrationTabUrl(url: string): boolean {
    const primarySegments = this.router.parseUrl(url).root.children.primary?.segments || []
    const path = primarySegments.map((segment) => segment.path).join('/')

    return path.startsWith('user/registrations') || path.startsWith('user/open-registration')
  }
}
